import { HorizontalDivider, VerticalDivider } from './Divider.styles';

interface Props {
  variant: 'horizontal' | 'vertical';
  color?: string;
  width?: string;
  height?: string;
  'data-testid'?: string;
  className?: string;
}

export const Divider = ({
  variant = 'horizontal',
  color,
  width,
  height,
  ...props
}: Props) => {
  switch (variant) {
    case 'horizontal':
      return (
        <HorizontalDivider
          $color={color}
          $width={width ?? '100%'}
          data-testid={props['data-testid']}
          className={props.className}
        />
      );
    case 'vertical':
      return (
        <VerticalDivider
          $color={color}
          $height={height ?? '100%'}
          data-testid={props['data-testid']}
          className={props.className}
        />
      );
  }
};
